import React, { useState } from 'react'
import * as Styled from './styled'
import { Checkbox } from '@designsforhealth/dfh-react-components'
import { TermsModal } from '../../terms/TermsModal'
import { TermsModalType } from '../../terms/types'
import { UseFormMethods } from 'react-hook-form'
import { PrivacyNoticeLink } from '../../terms/terms-links/PrivacyNoticeLink'
export interface RegistrationFormPatientAgreementProps {
  register: UseFormMethods['register']
}

export const RegistrationFormPatientAgreement: React.VFC<RegistrationFormPatientAgreementProps> = ({
  register,
}) => {
  const [currentlyOpenTermsModal, setCurrentlyOpenTermsModal] = useState<TermsModalType | null>(
    null
  )
  return (
    <Styled.CheckboxWrapper>
      <TermsModal
        currentlyOpenTermsModal={currentlyOpenTermsModal}
        open={!!currentlyOpenTermsModal}
        setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
      />
      <Checkbox
        label={
          <div data-cy="patient-agreement">
            I understand that by entering my information and clicking “Register” below, I am
            directing Designs for Health, Inc. to share my name, email address, and order history on
            an ongoing basis with the practitioner identified by the code above or selected by me on
            the next screen or otherwise, who may contact me at that address for consultation or
            about other products or services. For information about Designs for Health, Inc.’s
            privacy practices, I may visit Designs for Health’s{' '}
            <PrivacyNoticeLink setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal} />. For
            information about my healthcare practitioner’s privacy practices, I will contact my
            practitioner directly
          </div>
        }
        id="patientagreement"
        name="patientagreement"
        register={register}
        value=""
        defaultChecked={false}
      />
    </Styled.CheckboxWrapper>
  )
}
